// #region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
To format date
*/
import { format } from 'date-fns';
/**
To Time Picker control
*/
import TimePicker from './TimePicker';
/**
To Date Picker control
*/
import DatePicker from './DatePicker';
/**
To different icons
*/
import { IconChevron, IconClock, IconWheelchair, IconPedestrian, IconPhone } from '../Icons';
/**
Converts pickup type
*/
import {convertPickupType} from '../../utils/index';
//#endregion
/**
 * User in Planner>>Index
 */
class PlannerOptions extends React.Component {
    constructor(props) {
        super(props);
        //stores state values
        this.state = {
            //By default summary is collapsed or not
            collapsed: true
        };
    }
    /**
    * It is written in Planner>>PlannerOptions.
    * Used in same component.
    * mockWalkReluctanceField : The mockWalkReluctanceField is a field in OpenTripPlanner that is used to simulate a user's reluctance to walk.
    * mockMaxWalkField : The mockMaxWalkField is a field in OpenTripPlanner that is used to simulate a user's maximum walking distance. This field is used by the routing engine to calculate the best route between two points, and it can be used to prevent users from walking too far.
    * @param {Object} 'Event Object'
    */
    updateWalkPreferenceFields(event) {
        //set default values
        let mockWalkReluctanceField = {
            target: {
                name: 'walkReluctance',
                value: '3.0'
            }
        };
        let mockMaxWalkField = {
            target: {
                name: 'maxWalkDistance',
                value: '1600'
            }
        };
        //event.target.value : Walking Preference dropdown value
        switch(event.target.value) {
        case 'default':
            break;
        case 'less':
            mockWalkReluctanceField.target.value = '7.0';
            break;
        case 'no':
            mockWalkReluctanceField.target.value = '10.0';
            mockMaxWalkField.target.value = '50';
            break;
        case 'prefer':
            mockWalkReluctanceField.target.value = '1.0';
            mockMaxWalkField.target.value = '4000';
        }
        //Triggers updateFormField redux action  
        this.props.handleInput(mockMaxWalkField);
        this.props.handleInput(mockWalkReluctanceField);
    }

    //return summay text
    renderSummary() {
        //set leaving radio button value
        const leaving = this.props.form.arriveBy.value === 'true'
            ? 'Arriving by'
            : 'Departing after';
        //format date from mm/dd/yyyy to MMMM Do
        const optionsDate = format(this.props.form.date.value, 'MMMM Do');
        //save eligibilityText 
        const eligibilityText = getEligibilityDescription(this.props.form);
        //Takes Walking preference dropdown value and sets value 
        const walkingText = getWalkPreferenceText(this.props.form.walkPreference.value);
        return(
            <div className="otp-options-summary">
                <div className="otp-options-fields">
                    <div className="otp-form-row otp-datetime-summary">
                        <IconClock />
                        {leaving} {this.props.form.time.value} on {optionsDate}
                    </div>
                    <div className="otp-form-row otp-details-summary">
                        <div className="otp-eligibility-summary">
                            <IconWheelchair />
                            {/* Bug_issue-83 Changes -- Vishal Chauhan  Start */}
                            {/* Link: https://github.com/Trillium-Solutions/open-trip-planner-ui/issues/83 */}
                            <span id="eligibilityText">{eligibilityText}</span>
                            {/* Bug_issue-83 Changes -- Vishal Chauhan  End */}
                        </div>
                        <div className="otp-walking-summary">
                            <IconPedestrian />
                            {walkingText}
                        </div>
                    </div>
                </div>
                {/* show edit options if summay is not visible */}
                {!this.props.showSummary &&
                <div className="otp-edit-options">
                    <button
                        aria-label="Edit trip options"
                        onClick={() => this.setState({collapsed: false})} //show edit options
                    >
                        <IconChevron />
                    </button>
                </div>
                }
            </div>
        );
    }

    render() {
        //show summary if edit options is collapsed or showSummary value is true. 
        if (this.state.collapsed || this.props.showSummary) {
            return this.renderSummary();
        }
        return (
            <div className="otp-planner-options">
                <div className="otp-form-control">
                    <input
                        type="radio"
                        id="dep-after"
                        name="arriveBy"
                        value="false"
                        checked={this.props.form.arriveBy.value === 'false'}
                        onChange={this.props.handleInput}
                    />
                    <label htmlFor="dep-after">Depart After</label>
                    <input
                        type="radio"
                        id="arrive-by"
                        name="arriveBy"
                        value="true"
                        checked={this.props.form.arriveBy.value === 'true'}
                        onChange={this.props.handleInput}
                    />
                    <label htmlFor="arrive-by">Arrive By</label>
                </div>
                <div className="otp-form-row">
                    <div className="otp-form-control otp-has-dropdown otp-has-btn">
                        <label htmlFor="time" className="screen-reader-text">Time</label>
                        <input
                            name="time"
                            id="time"
                            type="text"
                            value={this.props.form.time.value}
                            onChange={this.props.handleInput}
                        />
                        <TimePicker
                            handleInput={this.props.handleInput}
                            value={this.props.form.time.value}
                        />
                    </div>
                    <div className="otp-form-control otp-has-dropdown">
                        <label htmlFor="date" className="screen-reader-text">Date</label>
                        <DatePicker
                            handleInput={this.props.handleInput}
                            value={this.props.form.date.value}
                        />
                    </div>
                </div>
                <div className="otp-form-row">
                    <div className="otp-form-control">
                        <label htmlFor="walkPreference">Walking Preference</label>
                        <select
                            name="walkPreference"
                            id="walkPreference"
                            onChange={event => {
                                this.updateWalkPreferenceFields(event);
                                this.props.handleInput(event);
                            }}
                            value={this.props.form.walkPreference.value}
                        >
                            <option value="default">Shortest Trip</option>
                            <option value="less">Less Walking</option>
                            <option value="no">No Walking</option>
                            <option value="prefer">Prefer Walking</option>
                        </select>
                    </div>
                    <div className="otp-form-control">
                        <input
                            type="checkbox"
                            checked={this.props.form.flexUseReservationServices.value === 'true'}
                            name="flexUseReservationServices"
                            id="flexUseReservationServices"
                            onChange={event => {
                                this.props.handleInput(event);
                                let dupeEvent = {target: {name: 'requiresReservation', value: convertPickupType(event.target.checked)}};
                                this.props.handleInput(dupeEvent);
                            }}
                        />
                        <label htmlFor="flexUseReservationServices">Include trips requiring reservations</label>
                    </div>
                    {!window.otpConfig.flex2 && 
                        <>
                            <div className="otp-form-control">
                                <input
                                    type="checkbox"
                                    checked={this.props.form.flexUseEligibilityServices.value === 'true'}
                                    name="flexUseEligibilityServices"
                                    id="flexUseEligibilityServices"
                                    onChange={this.props.handleInput}
                                />
                                <label htmlFor="flexUseEligibilityServices">Include trips with eligibility requirements</label>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }
}

/**
* It is written in Planner>>PlannerOptions.
* Used in same component.
* @param {Object} 'form Object'
* @return {String} Eligibility Text
*/
const getEligibilityDescription = form => {
    if (window.otpConfig.flex2) {
        //if "Include trips requiring reservations" checkbox is checked or not
        if (form.flexUseReservationServices.value === 'false') {
            //Bug_issue-76 Changes -- Vishal Chauhan  Start
            // return 'Please use checkbox below to remove/add trips requiring reservation';
            return 'Excluding trips with reservation requirements';
        } else {
            return 'Including trips with reservation requirements';
            //Bug_issue-76 Changes -- Vishal Chauhan  End
        }
    } else {
        //if reservations service and eligibility service is selected
        if ((form.flexUseReservationServices.value === 'true') && (form.flexUseEligibilityServices.value === 'true')) {
            return 'Showing ALL trips';
        }
        //if only eligibility service is selected
        if (form.flexUseEligibilityServices.value === 'true') {
            return 'Excluding trips with advance reservations';
        }
        //if only reservation service is selected
        if (form.flexUseReservationServices.value === 'true') {
            return 'Including trips with eligibility requirements'; //Bug_issue-76 Changes -- Vishal Chauhan 
        }
    }
    //return default text
    return 'Excluding trips with eligibility requirements or reservations';
};

/**
* It is written in Planner>>PlannerOptions .
* Used in same component.
* Takes Walk Preference dropdown value and convert into user readable text 
* @param {String} 'Walk Preference dropdown value'
* @return {String}  Walk Preference Text
*/
const getWalkPreferenceText = formValue => {
    switch(formValue) {
    case 'default':
        return 'Shortest trip';
    case 'less':
        return 'Minimize walking';
    case 'no':
        return 'No walking';
    case 'prefer':
        return 'Prefer walking';
    }
};

export default PlannerOptions;
